<script lang="ts">
	import { TableBodyCell, TableBodyRow } from "flowbite-svelte";
	import type { Folder } from "#gen/folder/v1/folders_pb.js";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import type { StaticAsset } from "#gen/staticassets/v1/static_assets_pb.js";
	import { isStaticAsset } from "#lib/bulk.js";
	import Checkbox from "#lib/components/Checkbox.svelte";
	import DateCell from "#lib/components/DateCell.svelte";
	import Icon from "#lib/components/Icon.svelte";
	import ProfileImage from "#lib/components/ProfileImage.svelte";
	import { getFileIcon } from "#lib/components/files/utils.js";

	interface Props {
		item: StaticAsset | Folder;
		selectedFile: StaticAsset | undefined;
		selectFile: (file: StaticAsset | Folder, checked: boolean) => void;
		getCreator: (userId: string | undefined) => User | undefined;
	}

	let { item, selectedFile, selectFile, getCreator }: Props = $props();

	let fileIcon = $derived(getFileIcon(isStaticAsset(item) ? item.mimeType : undefined));
	let checked = $derived(isStaticAsset(item) ? selectedFile?.uploadUrl === item.uploadUrl : false);

	function handleClickRow() {
		selectFile(item, true);
	}

	function handleCheckboxChange(e: Event) {
		if (isStaticAsset(item)) {
			selectFile(item, (e.currentTarget as HTMLInputElement).checked);
		}
	}
</script>

<TableBodyRow on:click={handleClickRow} data-action-name="file-explorer-selected-file-table-row cursor-pointer">
	<TableBodyCell>
		<div class="flex flex-row items-center">
			<Checkbox disabled={!isStaticAsset(item)} {checked} on:change={handleCheckboxChange} class="mr-4" data-action-name="file-explorer-selected-file-checkbox" />
			<div class="rounded bg-gray-100 px-2 py-2">
				<Icon name={fileIcon.name} iconSet={fileIcon.iconSet} />
			</div>
		</div>
	</TableBodyCell>
	<TableBodyCell>
		<span class="inline-block w-40 truncate whitespace-nowrap">{item.name}</span>
	</TableBodyCell>
	<TableBodyCell class="text-gray-500">
		<DateCell timestamp={item.createdAt} />
	</TableBodyCell>
	<TableBodyCell>
		<ProfileImage user={getCreator(isStaticAsset(item) ? item.creator?.userId : item.creatorId)} />
	</TableBodyCell>
</TableBodyRow>
